export interface IFormFieldValidator<T> {
  message: string;
  validateFn: (value?: T) => boolean;
}

type TValidationErrorFn = () => void;

export class FormField<T> {
  private readonly validators: IFormFieldValidator<T>[];
  private isDirty: boolean;
  public isValid: boolean;
  public value?: T;

  private onValidationErrorFn?: TValidationErrorFn;
  public onValidationError(fn?: TValidationErrorFn) {
    const isFunction = typeof fn === 'function';
    this.onValidationErrorFn = isFunction ? fn : undefined;
  }

  constructor(initialValue?: T) {
    this.value = initialValue;
    this.validators = [];
    this.isDirty = false;
    this.isValid = true;
  }

  public addValidator(validator: IFormFieldValidator<T>) {
    this.validators.push(validator);
  }

  public validate() {
    this.isDirty = true;
    return this.error;
  }

  public get error() {
    if (!this.isDirty) return '';

    for (const validator of this.validators) {
      if (!validator.validateFn(this.value)) {
        this.setInvalid();
        return validator.message;
      }
    }

    this.setValid();
    return '';
  }

  public reset(value?: T) {
    /**
     * если есть value, гарантируем обновление поля для vue-наблюдателей
     * (иначе не сработает для некорорых компонентов, возможно, особенность vue2)
     */
    this.value = undefined;
    this.value = value;
    this.isDirty = false;
  }

  private setInvalid() {
    if (!this.isValid) return;

    this.isValid = false;
    this.onValidationErrorFn?.();
  }

  private setValid() {
    this.isValid = true;
  }
}
